import React from "react";
import { Modal } from "react-responsive-modal";
import styles from "./ModalScreen.module.css";
import "react-responsive-modal/styles.css";

interface GalleryProps {
  onClose: Function;
  openVideo: boolean;
  children: any;
  transparent?: boolean;
}

const ModalScreen = ({
  transparent,
  children,
  openVideo,
  onClose,
}: GalleryProps) => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(openVideo);
  }, [openVideo]);

  return (
    <Modal
      open={open}
      blockScroll={false}
      onClose={() => onClose(false)}
      classNames={{
        overlay: styles["customGalleryOverlay"],
        modal: styles["customGalleryModal"],
      }}
    >
      {children}
    </Modal>
  );
};

export default ModalScreen;
